<!--
  FullCalendar finds its content templates with static queries, so a template inside an @if is never found,
  and a template that is always there replaces the default content. Each mix of the optional templates
  therefore gets its own <full-calendar>.
-->
@let eventTemplate = eventContent();
@let dayHeaderTemplate = dayHeaderContent();

@if (eventTemplate && dayHeaderTemplate) {
  <full-calendar [options]="calendarOptions()">
    <ng-template #eventContent let-arg>
      <ng-container [ngTemplateOutlet]="eventTemplate" [ngTemplateOutletContext]="{ $implicit: arg }" />
    </ng-template>
    <ng-template #dayHeaderContent let-arg>
      <ng-container [ngTemplateOutlet]="dayHeaderTemplate" [ngTemplateOutletContext]="{ $implicit: arg }" />
    </ng-template>
  </full-calendar>
} @else if (eventTemplate) {
  <full-calendar [options]="calendarOptions()">
    <ng-template #eventContent let-arg>
      <ng-container [ngTemplateOutlet]="eventTemplate" [ngTemplateOutletContext]="{ $implicit: arg }" />
    </ng-template>
  </full-calendar>
} @else if (dayHeaderTemplate) {
  <full-calendar [options]="calendarOptions()">
    <ng-template #dayHeaderContent let-arg>
      <ng-container [ngTemplateOutlet]="dayHeaderTemplate" [ngTemplateOutletContext]="{ $implicit: arg }" />
    </ng-template>
  </full-calendar>
} @else {
  <full-calendar [options]="calendarOptions()" />
}
